// AUTO-GENERATED FILE: This file is automatically generated when you create a custom component
// using `yarn create-custom-component <ComponentName>`. This is a starting template that you
// can and should edit to implement your component's admin configuration.
// Feel free to modify this file to add lazy loading, configure admin views, etc.
import type { AdminJsonComponentConfig } from '@apps/websiteCustomJsonComponents/JsonComponent.types';
import { loadable } from '@shared/core/loadableFromNamedExport';
import { StayBookingAssistantGrabber } from './StayBookingAssistantSidebar';
import { STAY_BOOKING_ASSISTANT_SCHEMA_URL, STAY_BOOKING_ASSISTANT_COMPONENT_TYPE } from './StayBookingAssistant.constants';

// Lazy load view components
const StayBookingAssistantAdd = loadable(
  () => import(/* webpackChunkName: "content/websiteEditorStayBookingAssistantAdd" */ './StayBookingAssistantSidebar'),
  'StayBookingAssistantAdd',
);

const StayBookingAssistantEdit = loadable(
  () => import(/* webpackChunkName: "content/websiteEditorStayBookingAssistantEdit" */ './StayBookingAssistantEdit'),
  'StayBookingAssistantEdit',
);

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
// Also add your type to the `CustomJSONComponentTypes` type in `src/apps/websiteCustomJsonComponents/types.ts`
export const StayBookingAssistantConfig: AdminJsonComponentConfig = {
  schemaUrl: STAY_BOOKING_ASSISTANT_SCHEMA_URL,
  componentType: STAY_BOOKING_ASSISTANT_COMPONENT_TYPE,
  adminSidebarComponent: {
    addComponentView: StayBookingAssistantAdd,
    dragComponentView: StayBookingAssistantGrabber,
    editComponentView: StayBookingAssistantEdit,
    createComponentView: StayBookingAssistantEdit,
  },
} as const;
